import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

import {ProcessTaskGraphQL} from '../../../graphql-fragments/processes/__generated/ProcessTaskGraphQL';
import * as ProcessManagementActions from '../ProcessManagementActions';

export interface CopyTasksProps {
  taskIds: Array<string>;
  onRequestClose: () => void;
  onRequestSubmit: (tasks: Array<ProcessTaskGraphQL> | null) => Promise<void>;
}

export default function CopyTasksConfirmationModal({
  taskIds,
  onRequestClose,
  onRequestSubmit,
}: CopyTasksProps): JSX.Element {
  async function handleSubmit(): Promise<void> {
    const tasksCopied = await ProcessManagementActions.copyTasks(taskIds);
    await onRequestSubmit(tasksCopied);
  }

  return (
    <Modal
      buttons={[
        {
          style: ButtonStyle.TERTIARY_GRAY,
          cancel: true,
          text: `Cancel`,
        },
        {
          style: ButtonStyle.PRIMARY,
          submit: true,
          text: `Continue`,
        },
      ]}
      title="Copy task(s) without assignee?"
      onRequestClose={onRequestClose}
      onRequestSubmit={handleSubmit}
    >
      Some of the copied tasks won't include their original assignee because their configuration doesn't allow
      setting assignees on creation. Set an assignee after copying tasks.
    </Modal>
  );
}
